/** Kinds of helpdesk tasks related to project */
export enum ProjectHelpdeskTasksKindEnum {
  /** All tasks */
  ALL = 'ALL',
  /** Tasks with active statuses */
  ACTIVE = 'ACTIVE',
  /** Tasks with finished statuses */
  FINISHED = 'FINISHED',
}
